export enum ExternalProvider {
  WITHINGS = 'Withings',
}
